import { Input, Tooltip } from "antd";
import React from "react";

function formatNumber(value) {
  value += "";
  const list = value.split(".");
  const prefix = list[0].charAt(0) === "-" ? "-" : "";
  let num = prefix ? list[0].slice(1) : list[0];
  let result = "";
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return `${prefix}${result}${list[1] ? `.${list[1]}` : ""}`;
}

export default class NumericInput extends React.Component {
  onChange = (e) => {
    const { value } = e?.target || {};
    const reg = /^-?\d*(\.\d*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
      this.props.onChange(value);
    }
  };

  // '.' at the end or only '-' in the input box.
  onBlur = () => {
    const { value, onBlur, onChange } = this.props;
    let valueTemp = value || "";
    if (valueTemp.charAt(valueTemp.length - 1) === "." || valueTemp === "-") {
      valueTemp = valueTemp.slice(0, -1);
    }
    onChange(valueTemp.replace(/0*(\d+)/, "$1"));
    if (onBlur) {
      onBlur();
    }
  };

  render() {
    const { value } = this.props;
    const safeValue = value || "";
    const title = safeValue ? (
      <span className="numeric-input-title">
        {safeValue !== "-" ? formatNumber(safeValue) : "-"}
      </span>
    ) : (
      "Input a number"
    );
    return (
      <Tooltip
        trigger={["focus"]}
        title={title}
        placement="topLeft"
        overlayClassName="numeric-input"
      >
        <Input
          {...this.props}
          onChange={this.onChange}
          onBlur={this.onBlur}
          placeholder="Input a number"
          maxLength={25}
        />
      </Tooltip>
    );
  }
}


class NumericInputDemo extends React.Component {
    constructor(props) {
      super(props);
      this.state = { value: '' };
    }
  
    onChange = value => {
      this.setState({ value });
    };
  
    render() {
      return (
        <NumericInput style={{ width: 120 }} value={this.state.value} onChange={this.onChange} />
      );
    }
  }